import React, { Suspense } from 'react';
import './App.css';
import './assets/stylesheets/workspace.css';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Loading } from './modules/home/Loading';
import { ICognitoUser } from './Authorization/Elements/AuthTypes';
import { PhoneStateContext } from './constants/constraints';
import { useSelector } from 'react-redux';
import { RootState } from './redux/store';
const AppRouter = React.lazy(() => import('./routes/AppRouter'));
const Authorization = React.lazy(() => import('./Authorization/Authorization').then(module => ({ default: module.Authorization })));

const App =()=> {
  console.debug(' --------------- APP - rendering ---------------'); 
  const { user } = useAuthenticator();
  const invoker = useSelector( (state: RootState) => state.callController.phoneEngineInvoker );
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  if (user && authStatus === "authenticated") {
    return (
      <Suspense fallback={<Loading name={'APP - ROUTER'} />} > 
        <PhoneStateContext.Provider value={{SendCommand:invoker}}>
          <AppRouter userProfile={user as unknown as ICognitoUser} /> 
        </PhoneStateContext.Provider>
      </Suspense> 
    );
  }

  return <Suspense fallback={<Loading name={'APP'} />} > <Authorization /> </Suspense>;  
}

export default App;
